import route from "@/router/index";
import {
  ACCESS_TOKEN_EXPIRED,
  ACCESS_TOKEN_NAME,
  AUTHORITIES_NAME,
  FULL_NAME,
  LOCATION_CODE_NAME, REFRESH_TOKEN_NAME,
  RESET_PASSWORD_REQUIRED,
  TIME_OTP_EXPIRED,
  USER_FULL_NAME,
  USER_ID,
  USER_NAME,
  USER_POSITION,
  CONFIG_AUTHORIZATION_CONNECT_PARTNER
} from "@/constant";
import securityCfg from "@/security/config";
import {disConnectSocket} from "@/socket";
import { CLIENT_ID } from "../constant";

const security = (function (router) {
  let userName;
  let fullName;
  let authorities;
  let authorizationMapper;
  let authenSuccesUrlRedirect;
  let userId;

  let initAuthorities = function () {
    let authoritiesStore = getAuthoritiesStore();
    authorities = new Map();
    for (let element of authoritiesStore) {
      // let author = element.authority;
      let author = element;
      authorities.set(author, author);
    }
  }

  let initAuthorizationMapper = function () {
    authorizationMapper = [];
    cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper);
  }

  let initAuthenSuccesUrlRedirect = function () {
    if (localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
      authenSuccesUrlRedirect = "/user/reset-password.html";
    } else {
      authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor);
    }
  }

  let initConfig = function () {
    initAuthorizationMapper();
    initAuthenSuccesUrlRedirect();
  }

  let initRouteFilter = function () {
    router.beforeEach((to, from, next) => {
      let _isLogin = isLogin();
      let _fullPath = to.fullPath;
      let _isAuthorized = isAuthorized(_fullPath);
      if (!_isLogin && (_fullPath === "/" || _fullPath.startsWith("/?"))) {
        next({name: 'UserLogin'});
      } else if (_isLogin && (_fullPath === "/" || _fullPath.includes("/login.html") || _fullPath === "/authorize")) {
        next(authenSuccesUrlRedirect);
      } else if (_isAuthorized) {
        if (localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
          if (!_fullPath.includes("/user/reset-password.html")) {
            next({path: '/user/reset-password.html'});
          } else {
            next();
          }
        } else {
          next();
        }
      } else if (!_isLogin) {
        next({name: 'UserLogin'})
      } else {
        next({name: 'page403'});
      }
    });
  }

  let cloneObjConfig = function (origin, target) {
    for (let attr in origin) {
      target[attr] = origin[attr];
    }
  }

  let isLogin = function () {
    return authorities && authorities.size;
  }

  let hasAuthor = function (author) {
    return authorities.has(author);
  }

  let isAuthorized = function (path) {
    let _isAuthorized = true;
    for (let authorCfg of authorizationMapper) {
      if (!(authorCfg.regex instanceof RegExp)) {
        console.log('author regex path undefined');
        continue;
      }
      if (authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === "function") {
        _isAuthorized &= authorCfg.isAuthorized(hasAuthor);
      }
    }
    return _isAuthorized;
  }

  let authLogin = function (access_token, refresh_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access_token);
    localStorage.setItem(REFRESH_TOKEN_NAME, refresh_token);
    localStorage.setItem(ACCESS_TOKEN_EXPIRED, access_token_exp);
    localStorage.setItem(AUTHORITIES_NAME, JSON.stringify(authoritiesStore));
    localStorage.setItem(USER_NAME, userName);
    localStorage.setItem(USER_FULL_NAME, fullName);
    localStorage.setItem(USER_ID, userId);
    if (lastUpdatePassword) {
      localStorage.setItem(RESET_PASSWORD_REQUIRED, lastUpdatePassword);
    }
    initAuthorities();
    setupUserInfor();
    initAuthenSuccesUrlRedirect();
    route.push({path: authenSuccesUrlRedirect});
  }

  let authLoginBySSO = function (access_token, authoritiesStore, userName, userId, exp_token, location_code, full_name, user_position) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access_token);
    localStorage.setItem(AUTHORITIES_NAME, JSON.stringify(authoritiesStore));
    localStorage.setItem(USER_NAME, userName);
    localStorage.setItem(USER_ID, userId);
    localStorage.setItem(ACCESS_TOKEN_EXPIRED, exp_token);
    localStorage.setItem(LOCATION_CODE_NAME, location_code);
    localStorage.setItem(USER_FULL_NAME, full_name);
    localStorage.setItem(USER_POSITION, user_position);
    initAuthorities();
    setupUserInfor();
    initAuthenSuccesUrlRedirect();
    route.push(authenSuccesUrlRedirect);
  }

  let clearLocalStorage = function () {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRED);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_FULL_NAME);
  }

  let authLogout = function () {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(REFRESH_TOKEN_NAME);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRED);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_FULL_NAME);
    localStorage.removeItem(FULL_NAME);
    localStorage.removeItem(RESET_PASSWORD_REQUIRED);
    localStorage.removeItem(TIME_OTP_EXPIRED);
    disConnectSocket();
    // localStorage.clear();
    if(CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      window.location.href = process.env.SSO_ADDRESS;
    } else {
      route.push({name: 'UserLogin'});
    }
    
  }

  let authAutoLogout = function () {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(REFRESH_TOKEN_NAME);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRED);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_FULL_NAME);
    localStorage.removeItem(FULL_NAME);
    localStorage.removeItem(RESET_PASSWORD_REQUIRED);
    localStorage.removeItem(TIME_OTP_EXPIRED);
    disConnectSocket();
    // localStorage.clear();
    if(CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      window.location.href = process.env.SSO_ADDRESS + `/login.html?redirect-uri=${encodeURIComponent(process.env.URI_REDIRECT)}&client-id=${CLIENT_ID}`;
    } else {
      route.push({name: 'UserLogin'});
    }
    
  }

  let getAuthoritiesStore = function () {
    let authoritiesStore;
    try {
      let _authoritiesStr = localStorage.getItem(AUTHORITIES_NAME);
      if (_authoritiesStr) {
        authoritiesStore = JSON.parse(_authoritiesStr);
      } else {
        authoritiesStore = []
      }
    } catch {
      authoritiesStore = [];
    }
    return authoritiesStore;
  }

  let getUserName = function () {
    return userName;
  }

  let getUserId = function () {
    return userId;
  }

  let getFullName = function () {
    return fullName;
  }

  let setupUserInfor = function () {
    userName = localStorage.getItem(USER_NAME);
    fullName = localStorage.getItem(USER_FULL_NAME);
    userId = localStorage.getItem(USER_ID);
  }

  let init = function () {
    initAuthorities();
    initConfig();
    setupUserInfor();
    initRouteFilter();
  }

  init();

  return {
    roles: securityCfg.roles,
    getUserName: getUserName,
    getFullName: getFullName,
    getUserId: getUserId,
    hasAuthor: hasAuthor,
    isAuthorized: isAuthorized,
    isLogin: isLogin,
    authLogin: authLogin,
    authLoginBySSO: authLoginBySSO,
    authLogout: authLogout,
    authAutoLogout: authAutoLogout,
  }
})(route);

export function roles() {
  return security.roles;
}

export function getUserName() {
  return security.getUserName();
}

export function getFullName() {
  return security.getFullName();
}

export function getUserId() {
  return security.getUserId();
}

export function hasAuthor(author) {
  return security.hasAuthor(author);
}

export function isAuthorized(path) {
  return security.isAuthorized(path);
}

export function authLogin(access_token, refresh_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword) {
  return security.authLogin(access_token, refresh_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword);
}

export function authLoginBySSO(access_token, authoritiesStore, userName, userId, exp_token, location_code, full_name, user_position) {
  return security.authLoginBySSO(access_token, authoritiesStore, userName, userId, exp_token, location_code, full_name, user_position);
}

export function authLogout() {
  return security.authLogout();
}

export function authAutoLogout() {
  return security.authAutoLogout();
}

export function isLogin() {
  return security.isLogin();
}
